import { BellIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import type { EdiPublishedNotice } from '@/api/hanly-v2/hanlyAPIV2.schemas';
import { formatYMDSlash } from '@/utils/date';

interface NoticeSectionProps {
  notices: EdiPublishedNotice[];
  limit: number;
  className?: string;
}

export const NoticeSection = ({ notices, limit, className }: NoticeSectionProps) => {
  const [expanded, setExpanded] = useState(false);

  if (notices.length === 0) {
    return null;
  }

  const visibleNotices = expanded ? notices : notices.slice(0, limit);
  const hiddenCount = notices.length - visibleNotices.length;

  return (
    <section aria-label="お知らせ" className={clsx('border border-neutral-200 bg-white', className)}>
      <div className="flex items-center gap-2 border-b border-neutral-200 px-3 py-2 md:px-4 md:py-2.5">
        <BellIcon className="size-5 text-sky-800" />
        <h3 className="text-[15px]">お知らせ</h3>
      </div>
      <ul className="divide-y divide-neutral-100 px-3 md:px-4 md:py-1">
        {visibleNotices.map((notice) => (
          <li
            key={notice.id}
            className="flex flex-col gap-0.5 py-2 text-sm md:flex-row md:items-baseline md:gap-4"
          >
            <span className="shrink-0 text-neutral-600 md:w-21">{formatYMDSlash(notice.start_date)}</span>
            <span className="min-w-0 flex-1 break-words">{notice.title}</span>
          </li>
        ))}
      </ul>
      {hiddenCount > 0 && (
        <div className="border-t border-neutral-200 md:px-4 md:py-1">
          <button
            type="button"
            onClick={() => setExpanded(true)}
            className="flex h-11 w-full cursor-pointer items-center justify-center gap-1 text-sm text-sky-800 md:h-10 md:w-auto md:justify-start md:px-1 hover:opacity-60"
          >
            ほか{hiddenCount}件を表示
            <ChevronDownIcon className="size-4" />
          </button>
        </div>
      )}
    </section>
  );
};
